const EMPLOYEE_IDENTITY_PATTERN = /^u_(.+)__[^_]+$/;
const GUEST_IDENTITY_PATTERN = /^g_(.+)__[^_]+$/;

export type RoomParticipant = { identity: string; joinedAtSeconds: number };

export function participantIdentity(userId: string, suffix: string) {
    return `u_${userId}__${suffix}`;
}

export function guestIdentity(guestId: string, suffix: string) {
    return `g_${guestId}__${suffix}`;
}

export function identityUserId(identity: string): string | null {
    return EMPLOYEE_IDENTITY_PATTERN.exec(identity)?.[1] ?? null;
}

export function identityGuestId(identity: string): string | null {
    return GUEST_IDENTITY_PATTERN.exec(identity)?.[1] ?? null;
}

export function isEmployeeInRoom(userId: string, participants: readonly Pick<RoomParticipant, 'identity'>[]) {
    return participants.some(({ identity }) => identityUserId(identity) === userId);
}

export function recordingStopperId(starterId: string | null, participants: readonly RoomParticipant[]): string | null {
    let earliest: { userId: string; joinedAtSeconds: number } | null = null;
    for (const { identity, joinedAtSeconds } of participants) {
        const userId = identityUserId(identity);
        if (!userId) continue;
        if (userId === starterId) return userId;
        const joinedEarlier =
            !earliest ||
            joinedAtSeconds < earliest.joinedAtSeconds ||
            (joinedAtSeconds === earliest.joinedAtSeconds && userId < earliest.userId);
        if (joinedEarlier) earliest = { userId, joinedAtSeconds };
    }
    return earliest?.userId ?? null;
}
